export const tableHeader = [
  "id",
  "nameRu",
  "status",
  "createdAt",
  "createdByUser",
  "updatedAt",
  "writtenByUser",
];
